import {
  getAutoRenewalsCall,
  getAutoRenewalDetailCall
} from "../services/mightyWifiApi";
import setAuthorizationToken from "../utils/setAuthorizationToken";
import {
  GET_AUTO_RENEWALS_SUCCESS,
  GET_AUTO_RENEWAL_DETAIL_SUCCESS
} from "./types";
import { SET_CURRENT_USER } from "./types";
export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user
  };
}

export function getAutoRenewals() {
  return dispatch => {
    return getAutoRenewalsCall()
      .then(res => {
        if (res.status) {
          dispatch({
            type: GET_AUTO_RENEWALS_SUCCESS,
            autoRenewalList: Object.assign([], res.data)
          });
        }
      })
      .catch(error => {
        if (error.response.status == 401) {
          localStorage.removeItem("jwtToken");
          setAuthorizationToken(false);
          dispatch(setCurrentUser({}));
        }
      });
  };
}

export function getAutoRenewalDetail(profileId) {
  return dispatch => {
    return getAutoRenewalDetailCall(profileId)
      .then(res => {
        if (res.status) {
          dispatch({
            type: GET_AUTO_RENEWAL_DETAIL_SUCCESS,
            autoRenewalDetail: Object.assign([], res.data)
          });
        }
      })
      .catch(error => {
        if (error.response.status == 401) {
          localStorage.removeItem("jwtToken");
          setAuthorizationToken(false);
          dispatch(setCurrentUser({}));
        }
      });
  };
}


// WEBPACK FOOTER //
// ./src/modules/actions/autoRenewalActions.js